export enum DriverActionTypes {
  LOAD_DRIVERS_REQUEST = 'LOAD_DRIVERS_REQUEST',
  LOAD_DRIVERS_SUCCEEDED = 'LOAD_DRIVERS_SUCCEEDED',
  LOAD_DRIVERS_FAILED = 'LOAD_DRIVERS_FAILED',

  SAVE_DRIVER_REQUEST = 'SAVE_DRIVER_REQUEST',
  SAVE_DRIVER_SUCCEEDED = 'SAVE_DRIVER_SUCCEEDED',
  SAVE_DRIVER_FAILED = 'SAVE_DRIVER_FAILED',

  DELETE_DRIVER_REQUEST = 'DELETE_DRIVER_REQUEST',
  DELETE_DRIVER_SUCCEEDED = 'DELETE_DRIVER_SUCCEEDED',
  DELETE_DRIVER_FAILED = 'DELETE_DRIVER_FAILED',

  SAVE_TOKEN_ASSOCIATION_REQUEST = 'SAVE_TOKEN_ASSOCIATION_REQUEST',
  SAVE_TOKEN_ASSOCIATION_SUCCEEDED = 'SAVE_TOKEN_ASSOCIATION_SUCCEEDED',
  SAVE_TOKEN_ASSOCIATION_FAILED = 'SAVE_TOKEN_ASSOCIATION_FAILED',

  TOKEN_VALIDATION_REQUEST = 'TOKEN_VALIDATION_REQUEST',
  TOKEN_VALIDATION_SUCCEEDED = 'TOKEN_VALIDATION_SUCCEEDED',
  TOKEN_VALIDATION_FAILED = 'TOKEN_VALIDATION_FAILED ',

  LOAD_TOKEN_ASSOCIATIONS_REQUEST = 'LOAD_TOKEN_ASSOCIATIONS_REQUEST',
  LOAD_TOKEN_ASSOCIATIONS_SUCCEEDED = 'LOAD_TOKEN_ASSOCIATIONS_SUCCEEDED',
  LOAD_TOKEN_ASSOCIATIONS_FAILED = 'LOAD_TOKEN_ASSOCIATIONS_FAILED',

  ON_DRIVER_DATA_FORM_CHANGE = 'ON_DRIVER_DATA_FORM_CHANGE',
}
